import { z } from 'zod';

// Wire contract: monorepo provider-registry/docs/provider-events.md.
export const PROVIDER_EVENTS_CHANNEL = 'provider-events:v1';
export const PROVIDER_EVENT_BROWSER_EVENT = 'berry-street:provider-event';
export const SUPPORT_INVALIDATE_EVENT = 'support.invalidate';
export const SUPPORT_CONVERSATION_CHANGED_EVENT =
  'support.conversation.changed';
export const supportConversationChangedSchema = z.object({
  conversationId: z
    .string()
    .min(1)
    .max(128)
    .regex(/^[a-zA-Z0-9_-]+$/),
});
export const providerEventSchema = z.object({
  version: z.literal(1),
  id: z.string().uuid(),
  providerId: z.string().uuid(),
  type: z
    .string()
    .min(1)
    .max(80)
    .regex(/^[a-z][a-z0-9]*(?:[._-][a-z0-9]+)*$/),
  payload: z.record(z.string(), z.unknown()),
  occurredAt: z.string().datetime(),
});
export type ProviderEvent = z.infer<typeof providerEventSchema>;
export type ProviderEventPacket = (
  | { kind: 'ready'; providerId: string }
  | { kind: 'event'; event: ProviderEvent }
) & {
  // Additive diagnostics; optional while old and new portal tasks coexist.
  connectionId?: string;
  correlationId?: string;
};
